export const defaultCenterCoord = { lat: 51.130316013258515, long: 71.43102000543827 };
